import { useEffect } from "react";
import { useMediaQuery } from "@crehana/react-hooks";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Drawer } from "@crehana/ui";
import useNewDashboardContext from "../context/useNewDashboardContext";
import Sidebar from "./Sidebar";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var DashboardMenu = function DashboardMenu(_ref) {
  var customHomeUrl = _ref.customHomeUrl,
    tourSelector = _ref.tourSelector,
    renderUpperLinks = _ref.renderUpperLinks,
    renderLinks = _ref.renderLinks,
    renderBottomLinks = _ref.renderBottomLinks,
    children = _ref.children,
    organizationLogo = _ref.organizationLogo,
    organizationSlug = _ref.organizationSlug,
    iconCollapse = _ref.iconCollapse,
    _ref$canRenderProduct = _ref.canRenderProductDropdown,
    canRenderProductDropdown = _ref$canRenderProduct === void 0 ? false : _ref$canRenderProduct,
    _ref$isSidebarV2Enabl = _ref.isSidebarV2Enabled,
    isSidebarV2Enabled = _ref$isSidebarV2Enabl === void 0 ? false : _ref$isSidebarV2Enabl,
    _ref$hasTalentProduct = _ref.hasTalentProduct,
    hasTalentProduct = _ref$hasTalentProduct === void 0 ? false : _ref$hasTalentProduct,
    isProduction = _ref.isProduction;
  var _useMediaQuery = useMediaQuery('md'),
    isMd = _useMediaQuery.matches;
  var _useNewDashboardConte = useNewDashboardContext(),
    isDark = _useNewDashboardConte.isDark,
    designMode = _useNewDashboardConte.designMode,
    sidebarCollapsed = _useNewDashboardConte.sidebarCollapsed,
    mobileSidebarOpen = _useNewDashboardConte.mobileSidebarOpen,
    toggleSideBar = _useNewDashboardConte.toggleSideBar,
    toggleMobileSideBar = _useNewDashboardConte.toggleMobileSideBar;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    // Close sidebar when is collapsed and is not desktop mode
    if (sidebarCollapsed && !isMd) {
      toggleSideBar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMd, sidebarCollapsed]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isMd ? /*#__PURE__*/_jsx(Sidebar, {
      renderUpperLinks: canRenderProductDropdown ? renderUpperLinks && renderUpperLinks.itemLinks : undefined,
      canRenderProductDropdown: canRenderProductDropdown,
      renderLinks: renderLinks.itemLinks,
      renderBottomLinks: renderBottomLinks && renderBottomLinks.itemLinks,
      customHomeUrl: customHomeUrl,
      tourSelector: tourSelector,
      organizationLogo: organizationLogo,
      organizationSlug: organizationSlug,
      hideActionCollapseButton: designMode === 'Overlay',
      iconCollapse: iconCollapse,
      isSidebarV2Enabled: isSidebarV2Enabled,
      hasTalentProduct: hasTalentProduct,
      hideBoxShadow: isSidebarV2Enabled,
      isProduction: isProduction
    }) : /*#__PURE__*/_jsx(Drawer, {
      isDark: isDark,
      open: mobileSidebarOpen,
      onDismiss: toggleMobileSideBar,
      position: "left",
      children: /*#__PURE__*/_jsx(Sidebar, {
        canRenderProductDropdown: canRenderProductDropdown,
        renderLinks: renderLinks.itemLinks,
        customHomeUrl: customHomeUrl,
        tourSelector: tourSelector,
        organizationLogo: organizationLogo,
        organizationSlug: organizationSlug,
        fullWidth: true,
        hideBoxShadow: true,
        hideActionCollapseButton: true,
        isSidebarV2Enabled: isSidebarV2Enabled,
        hasTalentProduct: hasTalentProduct,
        isProduction: isProduction
      })
    }), children]
  });
};
export default DashboardMenu;